import { render, staticRenderFns } from "./ProjectBenefit.vue?vue&type=template&id=55ddab49&scoped=true&"
import script from "./ProjectBenefit.vue?vue&type=script&lang=js&"
export * from "./ProjectBenefit.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBenefit.vue?vue&type=style&index=0&id=55ddab49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ddab49",
  null
  
)

export default component.exports